import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getDiameters(): Promise<any> {
  return await axiosInstance.get('/diameters', getDefaultRequestConfig());
}
